import { call } from '../core'

export interface ILogEventParams {
  name: string
  values?: object
}

export function sendLogEvent(params: ILogEventParams) {
  call('finLogEvent', params)
}
